import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RegioLockUserService } from 'app/services/regio-lock-user.service';
import {of} from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class RegioLockService {
    private URL: string = '/api/sensor';
    constructor(
        private httpService: HttpClient,
        private regioLockUserService: RegioLockUserService,
    ) {}

    getCodesForLocation(storageLocationId: string){
        return this.httpService.get(`${this.URL}/codes/${storageLocationId}`);
    }

    getEntryLogs(startDate: string, endDate: string, storageLocationId: string) {
       if(!storageLocationId) {return of(false);}
        return this.httpService.get(
            `${this.URL}/logs/${storageLocationId}?startDate=${startDate}&endDate=${endDate}`,
        );
    }

    getSensorValues(startDate: string, endDate: string, storageLocationId: string) {
        if(!storageLocationId) {return of(false);}
        return this.regioLockUserService.getSensorValues(startDate, endDate, storageLocationId);
    }

    /** Klima-Kurve mit Quellenwahl: UniFi-Protect-Sensor vor RegioLock-DHT22 */
    getClimate(startDate: string, endDate: string, storageLocationId: string) {
        if(!storageLocationId) {return of(false);}
        return this.httpService.get(
            `${this.URL}/climate/${storageLocationId}?startDate=${startDate}&endDate=${endDate}`,
        );
    }

    getDeviceStatus(storageLocationId: string) {
        if(!storageLocationId) {return of(false);}
        return this.regioLockUserService.getDeviceStatus(storageLocationId);
    }

    openDoor(storageLocationId: string) {
        return this.httpService.post(`${this.URL}/openDoor/${storageLocationId}`, null);
    }

    getDoorStatus(storageLocationId: string) {
        return this.httpService.get(`${this.URL}/doorStatus/${storageLocationId}`);
    }

    resetDevice(storageLocationId: string) {
        return this.httpService.post(`${this.URL}/resetDevice/${storageLocationId}`, null);
    }

    getDeviceRestartStatus(storageLocationId: string) {
        return this.httpService.get(`${this.URL}/resetDeviceStatus/${storageLocationId}`);
    }
}
